<template>
    <div class="set-component">
        <div class="set-header">账号安全</div>
        <div class="set-body">
            <el-form label-width="120px" size="small">
                <el-form-item label="修改密码">
                    <el-button size="mini" @click="showPasswordDialog">修改密码</el-button>
                </el-form-item>
                <el-form-item label="绑定手机">
                    <span>{{ securityInfo.phone || '未绑定' }}</span>
                    <el-button size="mini" style="margin-left: 12px;" @click="showPhoneDialog">{{ securityInfo.phone ? '更换手机' : '绑定手机' }}</el-button>
                </el-form-item>
                <el-form-item label="绑定邮箱">
                    <span>{{ securityInfo.email || '未绑定' }}</span>
                    <el-button size="mini" style="margin-left: 12px;" @click="showEmailDialog">{{ securityInfo.email ? '更换邮箱' : '绑定邮箱' }}</el-button>
                </el-form-item>
                <el-form-item label="实名认证">
                    <span v-if="securityInfo.realName" class="real-name-label">
                        <i class="el-icon-success" style="color: #67C23A; margin-right: 6px;"></i>已认证（{{ maskName(securityInfo.realName) }}）
                    </span>
                    <span v-else style="color: #F56C6C;">
                        <i class="el-icon-warning" style="margin-right: 6px;"></i>未认证
                    </span>
                    <el-button size="mini" style="margin-left: 12px;" @click="showRealNameAuthDialog">{{ securityInfo.realName ? '修改认证' : '去认证' }}</el-button>
                </el-form-item>
                <el-form-item label="登录设备">
                    <el-button size="mini" @click="showDeviceDialog">查看设备</el-button>
                </el-form-item>
            </el-form>

            <el-dialog title="修改密码" :visible.sync="passwordDialogVisible" width="400px" :modal-append-to-body="true" append-to-body custom-class="security-dialog">
                <el-form :model="passwordForm" :rules="passwordRules" ref="passwordFormRef" label-width="100px">
                    <el-form-item label="原密码" prop="oldPassword">
                        <el-input v-model="passwordForm.oldPassword" type="password" placeholder="请输入原密码" show-password />
                    </el-form-item>
                    <el-form-item label="新密码" prop="newPassword">
                        <el-input v-model="passwordForm.newPassword" type="password" placeholder="请输入新密码" show-password />
                    </el-form-item>
                    <el-form-item label="确认密码" prop="confirmPassword">
                        <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="请再次输入新密码" show-password />
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="passwordDialogVisible = false">取消</el-button>
                    <el-button type="primary" :loading="passwordLoading" @click="handleChangePassword">确定</el-button>
                </span>
            </el-dialog>

            <el-dialog title="绑定手机" :visible.sync="phoneDialogVisible" width="400px" :modal-append-to-body="true" append-to-body custom-class="security-dialog">
                <el-form :model="phoneForm" :rules="phoneRules" ref="phoneFormRef" label-width="100px">
                    <el-form-item label="手机号" prop="phone">
                        <el-input v-model="phoneForm.phone" placeholder="请输入手机号" />
                    </el-form-item>
                    <el-form-item label="验证码" prop="code">
                        <el-input v-model="phoneForm.code" placeholder="请输入验证码" style="width: 150px;" />
                        <el-button style="margin-left: 10px;" @click="sendPhoneCode" :disabled="phoneCodeDisabled">
                            {{ phoneCodeDisabled ? phoneCountdown + 's' : '发送验证码' }}
                        </el-button>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="phoneDialogVisible = false">取消</el-button>
                    <el-button type="primary" :loading="phoneLoading" @click="handleBindPhone">确定</el-button>
                </span>
            </el-dialog>

            <el-dialog title="绑定邮箱" :visible.sync="emailDialogVisible" width="400px" :modal-append-to-body="true" append-to-body custom-class="security-dialog">
                <el-form :model="emailForm" :rules="emailRules" ref="emailFormRef" label-width="100px">
                    <el-form-item label="邮箱" prop="email">
                        <el-input v-model="emailForm.email" placeholder="请输入邮箱地址" />
                    </el-form-item>
                    <el-form-item label="验证码" prop="code">
                        <el-input v-model="emailForm.code" placeholder="请输入验证码" style="width: 150px;" />
                        <el-button style="margin-left: 10px;" @click="sendEmailCode" :disabled="emailCodeDisabled">
                            {{ emailCodeDisabled ? emailCountdown + 's' : '发送验证码' }}
                        </el-button>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="emailDialogVisible = false">取消</el-button>
                    <el-button type="primary" :loading="emailLoading" @click="handleBindEmail">确定</el-button>
                </span>
            </el-dialog>

            <el-dialog title="实名认证" :visible.sync="realNameAuthVisible" width="450px" :modal-append-to-body="true" append-to-body custom-class="security-dialog">
                <!-- 已认证提示 -->
                <div class="auth-tip" v-if="realNameAuthForm.isAlreadyAuth">
                    <i class="el-icon-info"></i>
                    <span>您已完成实名认证，以下信息已遮盖显示。如需修改，请重新输入身份证号。</span>
                </div>
                <el-form :model="realNameAuthForm" :rules="realNameAuthRules" ref="realNameAuthFormRef" label-width="100px">
                    <el-form-item label="真实姓名" prop="realName">
                        <el-input v-model="realNameAuthForm.realName" placeholder="请输入真实姓名" />
                    </el-form-item>
                    <el-form-item label="身份证号" prop="cardNum">
                        <!-- 已认证：显示全星号，不可编辑，添加"重新输入"按钮 -->
                        <div class="cardNum-input-wrapper" v-if="realNameAuthForm.isAlreadyAuth">
                            <el-input
                                v-model="realNameAuthForm.cardNum"
                                type="password"
                                placeholder="已认证（已遮盖）"
                                :disabled="!realNameAuthForm.needReinput"
                                class="cardNum-masked-input"
                            />
                            <el-button
                                type="text"
                                size="mini"
                                @click="enableReinput"
                                v-if="!realNameAuthForm.needReinput"
                            >
                                <i class="el-icon-edit"></i> 重新输入
                            </el-button>
                        </div>
                        <!-- 未认证：正常输入 -->
                        <el-input
                            v-else
                            v-model="realNameAuthForm.cardNum"
                            placeholder="请输入18位身份证号"
                            maxlength="18"
                        />
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="realNameAuthVisible = false">取消</el-button>
                    <el-button type="primary" :loading="realNameAuthLoading" @click="handleRealNameAuth">提交认证</el-button>
                </div>
            </el-dialog>

            <el-dialog title="登录设备" :visible.sync="deviceDialogVisible" width="500px" :modal-append-to-body="true" append-to-body custom-class="security-dialog">
                <el-table :data="devices" style="width: 100%">
                    <el-table-column prop="device" label="设备" width="150" />
                    <el-table-column prop="location" label="位置" width="150" />
                    <el-table-column prop="lastTime" label="最后活跃时间" />
                </el-table>
                <span slot="footer">
                    <el-button @click="deviceDialogVisible = false">关闭</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { getUserInfo, updatePassword, updatePhone, updateEmail, updateRealNameAuth } from '@/api/settings';

export default {
    name: 'AccountSecurity',
    data() {
        return {
            securityInfo: { phone: '', email: '', realName: '', cardNum: '' },
            passwordDialogVisible: false,
            phoneDialogVisible: false,
            emailDialogVisible: false,
            realNameAuthVisible: false,
            deviceDialogVisible: false,
            passwordLoading: false,
            phoneLoading: false,
            emailLoading: false,
            realNameAuthLoading: false,
            realNameAuthForm: { realName: '', cardNum: '' },
            realNameAuthRules: {
                realName: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }, { min: 2, max: 20, message: '姓名长度2-20位', trigger: 'blur' }],
                cardNum: [{ required: true, message: '请输入证件号码', trigger: 'blur' }, { pattern: /^[0-9]{17}[0-9Xx]$/, message: '请输入正确的身份证号', trigger: 'blur' }]
            },
            passwordForm: { oldPassword: '', newPassword: '', confirmPassword: '' },
            passwordRules: {
                oldPassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
                newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }, { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }],
                confirmPassword: [{ required: true, message: '请再次输入新密码', trigger: 'blur' }, {
                    validator: (rule, value, callback) => this.validateConfirmPassword(rule, value, callback),
                    trigger: 'blur'
                }]
            },
            phoneForm: { phone: '', code: '' },
            phoneRules: {
                phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }],
                code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
            },
            emailForm: { email: '', code: '' },
            emailRules: {
                email: [{ required: true, message: '请输入邮箱地址', trigger: 'blur' }, { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }],
                code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
            },
            phoneCodeDisabled: false,
            phoneCountdown: 60,
            emailCodeDisabled: false,
            emailCountdown: 60,
            devices: []
        };
    },
    mounted() {
        this.loadSecurityInfo();
    },
    methods: {
        validateConfirmPassword(rule, value, callback) {
            if (value !== this.passwordForm.newPassword) {
                callback(new Error('两次输入密码不一致'));
            } else {
                callback();
            }
        },
        async loadSecurityInfo() {
            try {
                const res = await getUserInfo();
                if (res.data && res.data.code === 200) {
                    const data = res.data.data || {};
                    this.securityInfo = {
                        phone: data.phone || '',
                        email: data.email || '',
                        realName: data.realName || '',
                        cardNum: data.cardNum || ''
                    };
                }
            } catch (e) {
                console.error('获取安全信息失败', e);
            }
        },
        showPasswordDialog() {
            this.passwordForm = { oldPassword: '', newPassword: '', confirmPassword: '' };
            this.passwordDialogVisible = true;
        },
        async handleChangePassword() {
            this.$refs.passwordFormRef.validate(async (valid) => {
                if (!valid) return;
                this.passwordLoading = true;
                try {
                    const userId = this.getUserId();
                    const res = await updatePassword({
                        token: this.getToken(),
                        userId: userId,
                        oldPassword: this.passwordForm.oldPassword,
                        newPassword: this.passwordForm.newPassword,
                        confirmPassword: this.passwordForm.confirmPassword
                    });
                    if (res.data && res.data.code === 200) {
                        this.$message.success('密码修改成功');
                        this.passwordDialogVisible = false;
                    } else {
                        this.$message.error('修改失败：' + (res.data.msg || '未知错误'));
                    }
                } catch (e) {
                    this.$message.error('修改失败：' + (e.message || '未知错误'));
                } finally {
                    this.passwordLoading = false;
                }
            });
        },
        showPhoneDialog() {
            this.phoneForm = { phone: this.securityInfo.phone || '', code: '' };
            this.phoneDialogVisible = true;
        },
        sendPhoneCode() {
            if (!this.phoneForm.phone || !/^1[3-9]\d{9}$/.test(this.phoneForm.phone)) {
                this.$message.error('请输入正确的手机号');
                return;
            }
            this.$message.success('验证码已发送');
            this.phoneCodeDisabled = true;
            this.phoneCountdown = 60;
            const timer = setInterval(() => {
                this.phoneCountdown--;
                if (this.phoneCountdown <= 0) {
                    this.phoneCodeDisabled = false;
                    clearInterval(timer);
                }
            }, 1000);
        },
        async handleBindPhone() {
            this.$refs.phoneFormRef.validate(async (valid) => {
                if (!valid) return;
                this.phoneLoading = true;
                try {
                    const userId = this.getUserId();
                    const res = await updatePhone(userId, this.phoneForm.phone);
                    if (res.data && res.data.code === 200) {
                        this.$message.success('手机绑定成功');
                        this.securityInfo.phone = this.phoneForm.phone;
                        this.phoneDialogVisible = false;
                    } else {
                        this.$message.error('绑定失败：' + (res.data.msg || '未知错误'));
                    }
                } catch (e) {
                    this.$message.error('绑定失败：' + (e.message || '未知错误'));
                } finally {
                    this.phoneLoading = false;
                }
            });
        },
        showEmailDialog() {
            this.emailForm = { email: this.securityInfo.email || '', code: '' };
            this.emailDialogVisible = true;
        },
        sendEmailCode() {
            if (!this.emailForm.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.emailForm.email)) {
                this.$message.error('请输入正确的邮箱地址');
                return;
            }
            this.$message.success('验证码已发送');
            this.emailCodeDisabled = true;
            this.emailCountdown = 60;
            const timer = setInterval(() => {
                this.emailCountdown--;
                if (this.emailCountdown <= 0) {
                    this.emailCodeDisabled = false;
                    clearInterval(timer);
                }
            }, 1000);
        },
        async handleBindEmail() {
            this.$refs.emailFormRef.validate(async (valid) => {
                if (!valid) return;
                this.emailLoading = true;
                try {
                    const res = await updateEmail({
                        token: this.getToken(),
                        userId: this.getUserId(),
                        email: this.emailForm.email
                    });
                    if (res.data && res.data.code === 200) {
                        this.$message.success('邮箱绑定成功');
                        this.securityInfo.email = this.emailForm.email;
                        this.emailDialogVisible = false;
                    } else {
                        this.$message.error('绑定失败：' + (res.data.msg || '未知错误'));
                    }
                } catch (e) {
                    this.$message.error('绑定失败：' + (e.message || '未知错误'));
                } finally {
                    this.emailLoading = false;
                }
            });
        },
        maskName(name) {
            if (!name) return '';
            if (name.length <= 1) return name;
            if (name.length === 2) return name.charAt(0) + '*';
            return name.charAt(0) + '*'.repeat(name.length - 2) + name.charAt(name.length - 1);
        },
        maskCardNum(cardNum) {
            if (!cardNum) return '';
            if (cardNum.length < 8) return cardNum;
            return cardNum.substring(0, 4) + '**********' + cardNum.substring(cardNum.length - 4);
        },
        // 全星号遮盖身份证号（用于已认证用户显示）
        maskCardNumFull(cardNum) {
            if (!cardNum) return '';
            return '*'.repeat(cardNum.length);
        },
        showRealNameAuthDialog() {
            // 判断是否已认证
            const isAlreadyAuth = this.securityInfo.realName && this.securityInfo.cardNum;
            // 已认证：显示遮盖后的身份证号（全星号）
            // 未认证：显示空，让用户输入
            this.realNameAuthForm = {
                realName: this.securityInfo.realName || '',
                cardNum: isAlreadyAuth ? this.maskCardNumFull(this.securityInfo.cardNum) : '',
                // 保存原始身份证号，用于提交时判断是否需要重新输入
                originalCardNum: this.securityInfo.cardNum || '',
                isAlreadyAuth: isAlreadyAuth
            };
            this.realNameAuthVisible = true;
        },
        // 启用重新输入身份证号
        enableReinput() {
            this.realNameAuthForm.needReinput = true;
            this.realNameAuthForm.cardNum = ''; // 清空，让用户重新输入
            this.$message.info('请重新输入身份证号');
        },
        async handleRealNameAuth() {
            this.$refs.realNameAuthFormRef.validate(async (valid) => {
                if (!valid) return;
                this.realNameAuthLoading = true;
                try {
                    const userId = this.getUserId();
                    if (userId == null || userId === '') {
                        this.$message.error('用户未登录，请先登录');
                        this.realNameAuthLoading = false;
                        return;
                    }

                    // 判断提交的身份证号
                    let submitCardNum = this.realNameAuthForm.cardNum;
                    // 如果已认证且没有重新输入，则使用原始身份证号（不提交星号）
                    if (this.realNameAuthForm.isAlreadyAuth && !this.realNameAuthForm.needReinput) {
                        submitCardNum = this.realNameAuthForm.originalCardNum;
                    }

                    const res = await updateRealNameAuth({
                        token: this.getToken(),
                        userId: String(userId),
                        realName: this.realNameAuthForm.realName,
                        cardNum: submitCardNum
                    });
                    if (res.data && res.data.code === 200) {
                        this.$message.success('实名认证成功');
                        this.securityInfo.realName = this.realNameAuthForm.realName;
                        // 更新本地存储的身份证号
                        if (this.realNameAuthForm.needReinput) {
                            this.securityInfo.cardNum = this.realNameAuthForm.cardNum;
                        }
                        this.realNameAuthVisible = false;
                    } else {
                        this.$message.error('认证失败：' + (res.data.msg || '未知错误'));
                    }
                } catch (e) {
                    this.$message.error('认证失败：' + (e.message || '未知错误'));
                } finally {
                    this.realNameAuthLoading = false;
                }
            });
        },
        showDeviceDialog() {
            this.devices = [
                { device: 'Chrome on Windows', location: '北京', lastTime: '2024-01-15 10:30' },
                { device: 'Safari on iPhone', location: '上海', lastTime: '2024-01-14 20:15' }
            ];
            this.deviceDialogVisible = true;
        },
        getToken() {
            return '';
        },
        getUserId() {
            try {
                const user = JSON.parse(localStorage.getItem('userInfo') || '{}');
                return user ? (user.userId || user.id) : null;
            } catch (e) {
                return null;
            }
        }
    }
};
</script>

<style scoped>
.set-component {
    background: var(--card-background, #ffffff);
    border-radius: 12px;
    border: 1px solid var(--border-color-lighter, #eeeeee);
}
.set-header {
    padding: 18px 24px;
    font-size: 16px;
    font-weight: 600;
    color: var(--text-color, #333333);
    border-bottom: 1px solid var(--border-color-lighter, #eeeeee);
    display: flex;
    align-items: center;
    gap: 8px;
}
.set-header::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 18px;
    background: linear-gradient(135deg, #409EFF, #67C23A);
    border-radius: 2px;
}
.set-body {
    padding: 24px;
}

/* 表单项按钮美化 */
.set-body .el-form-item {
    margin-bottom: 20px;
}

.set-body .el-form-item__label {
    font-weight: 500;
    color: var(--text-color-secondary, #606266);
}

.real-name-label {
    color: #67C23A;
    font-weight: 500;
}

.set-body .el-button {
    border-radius: 14px;
    padding: 8px 16px;
    font-size: 12px;
    transition: all 0.2s;
}

.set-body .el-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 实名认证弹窗样式 */
.auth-tip {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: linear-gradient(135deg, rgba(103, 194, 58, 0.1), rgba(64, 158, 255, 0.05));
    border-radius: 8px;
    margin-bottom: 16px;
    font-size: 13px;
    color: #67C23A;
    border: 1px solid rgba(103, 194, 58, 0.2);
}

.auth-tip i {
    font-size: 16px;
}

.cardNum-input-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
}

.cardNum-masked-input {
    flex: 1;
}

.cardNum-masked-input .el-input__inner {
    background: #f5f7fa;
    letter-spacing: 2px;
}
</style>

<style>
/* 账号安全弹窗样式：确保弹窗在遮罩层之上 */
.security-dialog {
    z-index: 3100 !important;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);
    background: var(--card-background, #ffffff);
}

.security-dialog .el-dialog__header {
    padding: 18px 24px;
    border-bottom: 1px solid var(--border-color-lighter, #eeeeee);
    background: linear-gradient(135deg, rgba(64, 158, 255, 0.08), rgba(103, 194, 58, 0.05));
}

.security-dialog .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-color, #333333);
}

.security-dialog .el-dialog__body {
    padding: 20px 24px;
    color: var(--text-color, #333333);
}

.security-dialog .el-dialog__footer {
    padding: 14px 24px;
    border-top: 1px solid var(--border-color-lighter, #eeeeee);
}

/* 弹窗容器 wrapper 层级（必须高于 drawer 的 2200） */
body > .el-dialog__wrapper {
    z-index: 3050 !important;
}

/* 遮罩层必须在弹窗 wrapper 之下 */
body > .v-modal:last-of-type {
    z-index: 3049 !important;
    background-color: rgba(0, 0, 0, 0.4) !important;
}
</style>
